import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { ActiveFacetsService, SearchFacetService } from '../services';

/**
 * В рамках задачи https://jira.sdvor.com/browse/SPA-729
 * был произведен рефакторинг поисковых урлов. Но для обратной
 * совместимости необходимо поддерживать старый формат квери
 * параметров, до тех пор пока не выпилят старые урлы.
 * Данный гвард подменяет старые квери-параметры на новые.
 */
@Injectable({
  providedIn: 'root',
})
export class DeprecatedSearchParamsGuard implements CanActivate {
  constructor(
    private activeFacetsService: ActiveFacetsService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (route.queryParamMap.has('query')) {
      return this.activeFacetsService.paramsFromRouteState(route.data.cxRoute, route.params).pipe(
        map((params) => {
          const urlTree = this.router.parseUrl(state.url);
          const activeFacets = this.activeFacetsService.extractFacetsFromOldQueryParams(urlTree.queryParams.query);
          const facets = SearchFacetService.createSearchQuery({ ...params, activeFacets });
          const freeTextSearch = route.queryParams.freeTextSearch || route.params.query;
          const sort = route.queryParams.sortCode;

          delete urlTree.queryParams.query;
          delete urlTree.queryParams.sortCode;

          urlTree.queryParams = {
            ...urlTree.queryParams,
            ...(freeTextSearch && { freeTextSearch }),
            ...(sort && { sort }),
            facets,
          };

          return urlTree;
        }),
      );
    }

    return of(true);
  }
}
